import _defineProperty from "E:/code/jinhua-step-two/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { Component, Vue } from "vue-property-decorator";
import { getAllType, getScenic, initData } from "@/api/api";
import { themeColor, themeIcon } from "@/main";
let AroundRecommend = class AroundRecommend extends Vue {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "type_list", []);

    _defineProperty(this, "active_menu", 0);

    _defineProperty(this, "scenic_list", []);

    _defineProperty(this, "base_url", process.env.VUE_APP_BASE_URL);

    _defineProperty(this, "init_data", []);

    _defineProperty(this, "themeColor", themeColor);

    _defineProperty(this, "themeIcon", themeIcon);

    _defineProperty(this, "id", 0);
  }

  // 点击menu菜单
  async clickMenu(index) {
    if (this.active_menu !== index) {
      this.active_menu = index;
      await this.getScenic();
    }
  }

  async created() {
    const res = await getAllType(+this.$route.query.id);
    this.type_list = res.data;
    await this.getScenic();
    const initRes = await initData();
    this.init_data = initRes.data;
    this.id = JSON.parse(sessionStorage.getItem("scenic_data")).id;
  } // 跳转到首页


  clickScenic(item) {
    sessionStorage.setItem("point_id", item.id);
    sessionStorage.setItem("pointTypeId", item.pointTypeId);
    this.$router.push("scenic");
  } // 获取类型下的景点


  async getScenic() {
    const lng1 = sessionStorage.getItem("lng");
    const lat1 = sessionStorage.getItem("lat");
    const scenic_res = await getScenic(this.type_list[this.active_menu].id, lng1 || 1, lat1 || 1);
    this.scenic_list = scenic_res.data;
  }

  back() {
    this.$router.back();
  }

};
AroundRecommend = __decorate([Component], AroundRecommend);
export default AroundRecommend;